module.exports = __webpack_public_path__ + "static/media/(000127).59cbd622.jpg";